import { useState, useEffect, useCallback } from "react";
import ProfileHeader from "../components/profileSections/ProfileHeader";
import Packages from "../components/profileSections/Packages";
import Analytics from "../components/profileSections/Analytics";
import Portfolio from "../components/profileSections/Portfolio";
import Reviews from "../components/profileSections/Reviews";
import FAQ from "../components/profileSections/FAQ";
import SimilarInfluencers from "../components/profileSections/SimilarInfluencers";
import { getSimilarInfluencers } from "../services/marketplaceApi";

const InfluencerDetails = ({ influencer }) => {
  const [displayInfluencer, setDisplayInfluencer] = useState(influencer);
  const [similar, setSimilar] = useState([]);
  const [loadingSimilar, setLoadingSimilar] = useState(false);

  useEffect(() => {
    setDisplayInfluencer(influencer);
  }, [influencer]);

  useEffect(() => {
    if (!displayInfluencer?.username) return;

    const fetchSimilar = async () => {
      try {
        setLoadingSimilar(true);

        const similarInfluencers = await getSimilarInfluencers(
          displayInfluencer.username
        );

        if (similarInfluencers) {
          setSimilar(similarInfluencers);
        }
      } catch (error) {
        console.error("Error fetching similar influencers:", error);
        setSimilar([]);
      } finally {
        setLoadingSimilar(false);
      }
    };

    fetchSimilar();
  }, [displayInfluencer?.username]);

  const handleReviewSummaryChange = useCallback(({ averageRating, totalReviews }) => {
    setDisplayInfluencer((current) => {
      if (!current) {
        return current;
      }

      return {
        ...current,
        rating: averageRating,
        reviewCount: totalReviews,
      };
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 space-y-14">
      <ProfileHeader influencer={displayInfluencer} />
      <Analytics
        analytics={displayInfluencer?.analytics ?? {}}
        isVerified={Boolean(displayInfluencer?.isVerified)}
      />
      <Packages packages={displayInfluencer?.packages ?? {}} />
      <Portfolio items={displayInfluencer?.portfolio ?? []} />
      <Reviews
        influencer={displayInfluencer}
        onSummaryChange={handleReviewSummaryChange}
      />
      <FAQ faqs={displayInfluencer?.faqs ?? []} />
      {!loadingSimilar && similar.length > 0 && (
        <SimilarInfluencers
          influencers={similar}
          currentName={displayInfluencer?.name}
        />
      )}
    </div>
  );
};

export default InfluencerDetails;
